import { ValidationError } from './types'

/**
 * Normalizes what this section's endpoints can throw into something showable.
 *
 * Three shapes reach here and only the first was handled before (CPAYMENT-1723):
 * matching's structured `errors: [{code, message, fields}]` relayed on 422, the
 * backend's own `errors: {general: '…'}` object on 404/500, and nothing at all.
 * The `/internal/matching/profiles` URL is carved out of the axios interceptor's
 * generic error toast, so whatever this function misses is shown to the operator
 * as silence.
 *
 * The global interceptor rejects with `error.response`, so the body is at `e.data`
 * — `e.response.data` is kept as a fallback for direct axios errors.
 */
export const readApiError = (e: any, fallback = 'Не удалось выполнить операцию'): {
  errors: ValidationError[]
  message: string
} => {
  const body = e?.data ?? e?.response?.data
  const status: number | undefined = e?.status ?? e?.response?.status
  const raw = body?.errors

  if (Array.isArray(raw) && raw.length) {
    // `message` is filled here too: callers without a form to highlight (the
    // «Активен» switch, delete) still need the concrete reason, not the fallback.
    const errors = raw as ValidationError[]
    const texts = Array.from(new Set(errors.map((x) => x.message).filter(Boolean)))
    return { errors, message: texts.length ? texts.join('\n') : fallback }
  }

  const texts: string[] = []
  if (raw && typeof raw === 'object') {
    Object.values(raw).forEach((v) => {
      if (typeof v === 'string' && v) texts.push(v)
    })
  }
  if (!texts.length && typeof body?.message === 'string' && body.message) texts.push(body.message)

  const suffix = status ? ` (${status})` : ''
  return { errors: [], message: texts.length ? texts.join('\n') : `${fallback}${suffix}` }
}
